export default __webpack_public_path__ + "static/media/Union-Pay.13a4364f.svg";